import script from "./editPassword.vue?vue&type=script&setup=true&lang=js"
export * from "./editPassword.vue?vue&type=script&setup=true&lang=js"

import "./editPassword.vue?vue&type=style&index=0&id=fc8f68e2&lang=scss&scoped=true"

import exportComponent from "/var/www/ddup_czb/slczb_app_web/view/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc8f68e2"]])

export default __exports__